import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { TransportistaService } from '../../../services/TransportistaService';
import { Validators } from '../../../components/CatalogForm/validators';

const transportistaFields = [
  {
    name: 'transportista',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. TR-001',
    validators: [Validators.required('La clave del transportista es obligatoria')],
  },
  {
    name: 'transportista_nombre',
    label: 'Nombre',
    type: 'text',
    col: 8,
    placeholder: 'Ej. Transportes del Norte S.A. de C.V.',
    validators: [Validators.required('El nombre del transportista es obligatorio')],
  },
];

export const TransportistaForm = () => {
  const { id } = useParams();

  const handleLoadData = async (transportistaId) => {
    return await TransportistaService.obtenerPorId(transportistaId);
  };

  const handleSubmit = async (values) => {
    return await TransportistaService.guardar(values);
  };

  return (
    <CatalogForm
      title="Transportista"
      subtitle="Complete los datos del transportista"
      fields={transportistaFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/Transportistas"
    />
  );
};

export default TransportistaForm;
